import React, { Component } from 'react';
import { Select } from 'antd';
import { queryIncCustomList } from '@api/incubator/custom';

const { Option } = Select;

class SelectCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customList: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.incubatorUuid = this.props.incubatorUuid || '';
    this.condition = this.props.customName || '';
    this.getIncCustomList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incubatorUuid !== this.props.incubatorUuid) {
      this.incubatorUuid = nextProps.incubatorUuid || '';
      this.condition = nextProps.customName || '';
      this.getIncCustomList();
    }
  }

  handleSearch = value => {
    this.condition = value;
    this.getIncCustomList(value);
  };

  getIncCustomList = () => {
    queryIncCustomList({
      condition: this.condition || '',
      incubatorUuid: this.incubatorUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          customList: res.data,
        });
      }
    });
  };

  render() {
    const customList = this.state.customList || [];
    return (
      <Select
        onChange={this.props.onChange}
        showSearch
        filterOption={false}
        onSearch={this.handleSearch}
        style={{ width: '300px' }}
        value={this.props.value}
      >
        {customList.map(item => {
          return <Option key={item.customUuid}>{item.customName}</Option>;
        })}
      </Select>
    );
  }
}
export default SelectCustom;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/SelectCustom.js